import { ApiSanctionEntity, ApiSanctionEntityType } from '../api/models';

export const getValueFromEntityByFieldKey = (
  fieldKey: string | undefined,
  entity: ApiSanctionEntity
): string | undefined => {
  const attributes =
    entity.entityType === ApiSanctionEntityType.PERSON ? entity.person?.attributes : entity.transaction?.attributes;
  if (attributes && fieldKey) {
    return fieldKey
      ?.split(' ')
      .map((key) => attributes[key])
      .filter((val) => val && val.trim().length > 0)
      .join(' ');
  }
};
